import { Component, input, output } from '@angular/core';


export interface NavigationCard {
  title: string;
  description: string;
  route: string;
  iconPath: string;
  isEnabled: boolean;
}

@Component({
  standalone: true,
  imports: [],
  selector: 'app-navigation-card',
  template: `
    <button
      (click)="onNavigate()"
      class="group bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:shadow-md hover:border-orange-300 transition-all duration-200 text-left"
    >
      <div class="flex items-center mb-4">
        <div
          class="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center group-hover:bg-orange-200 transition-colors duration-200"
        >
          <svg
            class="w-6 h-6 text-orange-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              [attr.d]="iconPath()"
            />
          </svg>
        </div>
      </div>
      <h3 class="text-lg font-semibold text-gray-800 mb-2">
        {{ title() }}
      </h3>
      <p class="text-sm text-gray-500">
        {{ description() }}
      </p>
    </button>
  `,
})
export class NavigationCardComponent {
  // Inputs
  title = input.required<string>();
  description = input.required<string>();
  route = input.required<string>();
  iconPath = input.required<string>();

  // Outputs
  navigate = output<string>();

  onNavigate(): void {
    this.navigate.emit(this.route());
  }
}
